import { useMutation } from '@tanstack/react-query';

import {
  addFolderItem,
  removeFolderItem,
  reorderFolderItems,
} from '../fetchers';

import { useSyncFolder } from './useSyncFolder';

export const useAddFolderItem = () => {
  const sync = useSyncFolder();
  return useMutation({
    scope: { id: 'folder-items' },
    mutationFn: ({
      id,
      quizsetId,
      confirmSourcePublication = false,
    }: {
      id: string;
      quizsetId: string;
      confirmSourcePublication?: boolean;
    }) => addFolderItem(id, quizsetId, confirmSourcePublication),
    onSuccess: folder => sync(folder),
  });
};

export const useRemoveFolderItem = () => {
  const sync = useSyncFolder();
  return useMutation({
    scope: { id: 'folder-items' },
    mutationFn: ({ id, quizsetId }: { id: string; quizsetId: string }) =>
      removeFolderItem(id, quizsetId),
    onSuccess: folder => sync(folder),
  });
};

/**
 * 순서 변경.
 *
 * 추가·삭제와 **같은 스코프**를 쓴다 — 셋이 같은 목록을 건드리므로 동시에 나가면 서버가 보는
 * 순서와 화면이 갈린다. 스코프가 같으면 react-query 가 직렬화해 준다.
 *
 * 응답의 `items` 는 **미리보기 4개**라 상세 캐시에 써넣지 않는다(`useSyncFolder` 의 이유와 동일).
 * 무효화만 하고 목록은 커서 첫 페이지부터 다시 받는다.
 */
export const useReorderFolderItems = () => {
  const sync = useSyncFolder();
  return useMutation({
    scope: { id: 'folder-items' },
    mutationFn: ({
      id,
      orderedQuizsetIds,
    }: {
      id: string;
      orderedQuizsetIds: string[];
    }) => reorderFolderItems(id, orderedQuizsetIds),
    onSuccess: folder => sync(folder),
  });
};
